import { inject, Provider } from '@angular/core';
import { HomeworkActivityCompletionData, HomeworkActivityQuery, HomeworkActivityService } from '@examdojo/homework';
import {
  ACTIVITY_COMPLETION_DATA_PROVIDER,
  ActivityCompletionData,
  ActivityCompletionDataProvider,
  QUESTION_ATTEMPT_FULLSCREEN_FLOW_CONFIG,
} from '@examdojo/question';
import { isNotNullish } from '@examdojo/util/nullish';
import { distinctUntilChanged, filter, map, of, switchMap } from 'rxjs';

function mapToActivityCompletionData(data: HomeworkActivityCompletionData): ActivityCompletionData {
  return {
    totalMarks: data.total_marks,
    awardedMarks: data.awarded_marks,
    timeSpentMs: data.time_spent_ms,
    pacePerMark: data.pace_per_mark,
    paceBoundaries: data.pace_boundaries,
    paceChartIndex: data.pace_chart_index,
  };
}

export function provideFullscreenFlowConfig(): Provider[] {
  return [
    {
      provide: ACTIVITY_COMPLETION_DATA_PROVIDER,
      useFactory: (): ActivityCompletionDataProvider => {
        const homeworkActivityQuery = inject(HomeworkActivityQuery);
        const homeworkActivityService = inject(HomeworkActivityService);

        return {
          completionData$: homeworkActivityQuery.ongoingActivity$.pipe(
            filter(isNotNullish),
            filter((activity) => isNotNullish(activity.question_attempt_id)),
            distinctUntilChanged((a, b) => a.id === b.id && a.question_attempt_id === b.question_attempt_id),
            switchMap((activity) =>
              homeworkActivityService.getCompletionData(activity.id, activity.question_attempt_id!),
            ),
            map(mapToActivityCompletionData),
          ),
        };
      },
    },
    {
      provide: QUESTION_ATTEMPT_FULLSCREEN_FLOW_CONFIG,
      useValue: { skipFullscreenFlow$: of(false) },
    },
  ];
}
